module.exports = __webpack_public_path__ + "files/be4fc180dfd25526c7aa94c36ef77da1.png";